<template>
  <span v-if="session.testmode" class="inline-flex items-center rounded-full bg-markencode-blue px-2 py-1 text-xs font-medium text-white">Test</span>
</template>

<script>
export default {
  props: {
    session: {
      type: Object,
      required: true,
    },
  },
};
</script>
